import { render, staticRenderFns } from "./BlankPage.vue?vue&type=template&id=040dd11e&"
import script from "./BlankPage?vue&type=script&lang=ts&"
export * from "./BlankPage?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports